import { apiFetch } from '../client';
import Cookies from 'js-cookie';

export function getShapeInfo(geojson) {
    return apiFetch('/map-api-data/', {
        method: 'POST',
        body: JSON.stringify(geojson)
    })
}

/**
 * Batch polygon / multipolygon areas in hectares (WGS84 → SWEREF99 TM on server).
 * @param {Array<object | null | undefined>} geometries GeoJSON Polygon or MultiPolygon dicts
 */
export function fetchPolygonAreasHa(geometries) {
    return apiFetch('/map-api/polygon-areas-ha/', {
        method: 'POST',
        body: JSON.stringify({ geometries })
    })
}

export function fetchGeojsonData(geojson){
    return apiFetch('/map-api/divide-and-data-only/',{
        method: 'POST',
        body:JSON.stringify(geojson)
    })
}

export function forestAgencyFellingBuffer(geom, buffer=null){
    let data = {geom:geom}
    if(buffer !== null){
        data.buffer=buffer;
    }
    return apiFetch('/forestagency/finalfelling-application/buffer/',{
        method: 'POST',
        body: JSON.stringify(data)
    })
}

export function uploadAdFile(fileFormData) {
  return apiFetch('/auctions-api/file/', {
    method: 'POST',
    body: fileFormData,
    headers: {
      'Accept': 'application/json'
    }
  });
}
export function createAdAttachment(fileData, id) {
  return apiFetch('/auctions-api/auctionsattachment/', {
    method: 'POST',
    body: JSON.stringify({
      ad: parseInt(id),
      file: fileData.id
    }),
  });
}


export function deleteAdAttachmentsNew(file_id){
    let url="/auctions-api/auctionsattachment/"
    return apiFetch(url + file_id.toString() + "/",{
        method: 'DELETE'
    })
}

export function adApiRequest(method = 'GET',ad_id, data = null) {
  const headers = { 'Content-Type': 'application/json', 'X-CSRFToken': Cookies.get('csrftoken') };
  const options = {
    method: method,
    credentials: 'same-origin',
    headers: headers
  };

  if (data) {
    options.body = JSON.stringify(data);
  }

  return apiFetch(`/auctions-api/auctions/${ad_id}/`, options);
};
export function sendAdForReview(url){
    return apiFetch(url,{
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: "review=1"
    })
}

/**
 * POST to `/auctions-api/auctions/:id/submit-for-review/` (JSON). Transitions CREATED → WAITING_FOR_REVIEW
 * without requiring a full seller profile on the request. If the profile is still incomplete,
 * the response includes `needs_profile_redirect` and `redirect_url` (same idea as the HTML
 * `/auctions/:id/review/` flow).
 *
 * @returns {Promise<{ ok: true, status: number, data?: unknown } | { ok: false, needsRedirect?: true, redirectUrl?: string, status?: number, data?: unknown, message?: string }>}
 */
export async function submitAdForReviewById(adId) {
    const res = await apiFetch(`/auctions-api/auctions/${adId}/submit-for-review/`, {
        method: 'POST',
        body: '{}',
    });

    if (!res.ok) {
        return {
            ok: false,
            status: res.status,
            data: res.data,
            message: res.message,
        };
    }

    const d = res.data || {};
    if (d.needs_profile_redirect && d.redirect_url) {
        return {
            ok: false,
            needsRedirect: true,
            redirectUrl: d.redirect_url,
            status: res.status,
        };
    }

    return {
        ok: true,
        status: res.status,
        data: d,
    };
}

export function bookmarkAd(url){
    return apiFetch(url,{
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: "bookmarked=1",
    })
}

// Bids api
export function createSimpleBidNew(comments, files, ad_id){
    const formData = new FormData();
    files.forEach((file) => {
        formData.append('attachments', file);
    });
    formData.append("comments", comments)
    formData.append("ad_id", ad_id)

    return apiFetch("/bid-api/simple/", {
        method:"POST",
        body: formData,
        headers: {
            'X-CSRFToken': Cookies.get('csrftoken'), // REQUIRED manually
        },
    })
}

export function selectWinningBidNew(bid_id){
    return apiFetch("/bid-api/select-winner/", {
        method:"POST",
        credentials: 'same-origin',
        body: JSON.stringify({"ad_id": Window.react_data.ad.id, "bid_id": bid_id})
    })
}
